/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class IndexController extends Controller {
  queryParams = ['title', 'state'];

  @tracked title: string | null = null;
  @tracked state: string | null = null;
}
